import { CertificatePageNumber, ContactPageNumber, ExteriorPageNumber, HistoryPageNumber, ImageCapturePageNumber, InteriorPageNumber, MechanicalPageNumber, VehiclePageNumber } from '../../../constants'
export const PAGE_TYPE = {
  trade: 'trade'
}

export const ELEMENT_TITLE = {
  [VehiclePageNumber]: 'vehicle_details',
  [HistoryPageNumber]: 'vehicle_history',
  [ImageCapturePageNumber]: 'vehicle_photos',
  [ExteriorPageNumber]: 'vehicle_condition',
  [InteriorPageNumber]: 'vehicle_condition',
  [MechanicalPageNumber]: 'vehicle_condition',
  [ContactPageNumber]: 'contact_details',
  [CertificatePageNumber]: 'certificate'
}

export const ELEMENT_TEXT = {
  next: 'Next',
  back: 'Back',
  continue: 'Continue',
  go: 'Go',
  startMyOffer: 'Start My Offer',
  getMyOffer: 'Get My Offer',
  getStarted: 'Get Started',
  requestAppointment: 'Request Appointment',
  seeStandardEquipment: 'See standard equipment',
  seeAllFeaturesEquipment: 'See all features & equipment',
  faq: 'FAQ',
  email: 'Email',
  print: 'Print',
  call: 'Call',
  reviewVehicleDetails: 'Review vehicle details',
  sitelink: 'Dealer Website',
  phone: 'Phone',
  map: 'More Info',
  'get-directions': 'Get Directions',
  yesItIsPerfect: "Yes! It's Perfect",
  exhaust: 'Exhaust',
  performance: 'Performance Modifications',
  stereo: 'Stereo',
  suspension: 'Suspension',
  wheelsTires: 'Wheels & Tires'
}

export const ELEMENT_TYPE = {
  trade_tool: 'trade_tool'
}

export const EVENT_ACTION = {
  click: 'click'
}

export const EVENT_ACTION_RESULT = {
  start: 'start',
  error: 'error',
  popup: 'popup',
  close: 'close',
  complete: 'complete',
  declined: 'declined',
  exit: 'exit',
  open: 'open',
  none: 'none',
  restart: 'restart'
}

export const ELEMENT_SUB_TYPE = {
  hyperlink: 'hyperlink',
  icon: 'cta_icon',
  button: 'cta_button'
}

export const DEPARTMENT = {
  trade: 'trade'
}

export const FORM_TYPE = {
  trade: 'trade'
}

export const FLOW_NAME = {
  trade: 'trade'
}

export const FLOW_OUTCOME = {
  start: 'start',
  proceed: 'proceed',
  back: 'back',
  submit: 'submit',
  value_provided: 'value_provided',
  value_not_provided: 'value_not_provided',
  error: 'error',
  close: 'close',
  finished: 'finished'
}

export const CRM_UPDATE = 'crm_update'
export const OPPORTUNITY = 'opportunity'

export const COMM_OUTCOME = {
  crm_update: { comm_outcome: CRM_UPDATE },
  opportunity: { comm_outcome: OPPORTUNITY }
}

export const COMM_TYPE = {
  form: { comm_type: 'form' }
}
